// import React from "react";
// import "../studentform.css";

// export default function RegistrationForm() {
//   return (
//     <div className="form-wrapper">
//       <div className="form-header">
//         <h3>FILL THE FORM FOR A CALL BACK REQUEST</h3>
//         <p>(Internship details, curriculum, will be sent to you upon request)</p>
//       </div>

//       <form className="form-box">
//         <label>Name:</label>
//         <input type="text" placeholder="Your answer" required />

//         <label>Email:</label>
//         <input type="email" placeholder="Your answer" required />

//         <label>Contact Number:</label>
//         <input type="number" placeholder="Your answer" required />

//         <label>Whatsapp Number:</label>
//         <input type="number" placeholder="Your answer" required />

//         <label>College Name:</label>
//         <input type="text" placeholder="Your answer" required />

//         <label>Year Of Study :</label>
//         <select required>
//           <option value="">Select a year...</option>
//           <option value="1st Year">1st Year</option>
//           <option value="2nd Year">2nd Year</option>
//           <option value="3rd Year">3rd Year</option>
//           <option value="4th Year">4th Year</option>
//           <option value="Graduate">Graduate</option>
//         </select>

//         <label>Branch/Department:</label>
//         <input type="text" placeholder="Your answer" required />

//         <label>Domains Of Internship:</label>
//         <select required>
//           <option value="">Select a Domain...</option>
//           <option>Android App Development</option>
//           <option>Artifical Inteligence</option>
//           <option>AR/VR</option>
//           <option>Autocad</option>
//           <option>Bio Informatics</option>
//           <option>Business Analytics</option>
//           <option>C, C++ With DSA</option>
//           <option>Car Design</option>
//           <option>Cloud Computing</option>
//           <option>Cyber Security</option>
//           <option>Data Science</option>
//           <option>Digital Markeing & Marketing</option>
//           <option>Embedded Systems</option>
//           <option>Finance</option>
//           <option>Full Stack Web Development</option>
//           <option>Generative AI</option>
//           <option>Genetic Engineering</option>
//           <option>Graphic Design</option>
//           <option>Human Resources</option>
//           <option>(HEV) Hybrid Electric Vehicle</option>
//           <option>IC Engine</option>
//           <option>Internet Of Things (IOT)</option>
//           <option>Java</option>
//           <option>Machine Learning With Python</option>
//           <option>Mern Stack</option>
//           <option>Nanoscience Nanotechnology</option>
//           <option>Psychology</option>
//           <option>Python</option>
//           <option>Regulatory Affairs (In Pharma & Healthcare)</option>
//           <option>Robotics</option>
//           <option>Stock Market</option>
//           <option>Supply Chain Management</option>
//           <option>UI/UX Design</option>
//           <option>VlSI Design</option>
//           <option>Web Development</option>
//         </select>

//         <label>Any Referral Of Friends (Name & Contact Number):</label>
//         <input type="text" placeholder="Your answer" />
//         <button className="submit-btn">Submit</button>
//       </form>
//     </div>
//   );
// }


import React, { useState } from "react";
import "../studentform.css";

export default function RegistrationForm() {
  
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbylqgQCII-mTc7gyy_FJrQ1SyNTds_QSLv9zJO2cf_r3bBqAGfda77B8LA39a_I6gRQ/exec";

  const [form, setForm] = useState({
    name: "",
    email: "",
    contact: "",
    whatsapp: "",
    college: "",
    year: "",
    branch: "",
    domain: "",
    referral: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch(SCRIPT_URL, {
      method: "POST",
      body: JSON.stringify(form),
    });

    alert("Your form has been submitted successfully!");
    setForm({
      name: "",
      email: "",
      contact: "",
      whatsapp: "",
      college: "",
      year: "",
      branch: "",
      domain: "",
      referral: "",
    });
  };

  return (
    <div className="form-wrapper">
      <div className="form-header">
        <h3>FILL THE FORM FOR A CALL BACK REQUEST</h3>
        <p>(Internship details will be sent to you)</p>
      </div>

      <form className="form-box" onSubmit={handleSubmit}>

        <label>Name:</label>
        <input name="name" value={form.name} onChange={handleChange} required />

        <label>Email:</label>
        <input name="email" type="email" value={form.email} onChange={handleChange} required />

        <label>Contact Number:</label>
        <input name="contact" type="number" value={form.contact} onChange={handleChange} required />

        <label>Whatsapp Number:</label>
        <input name="whatsapp" type="number" value={form.whatsapp} onChange={handleChange} required />

        <label>College Name:</label>
        <input name="college" value={form.college} onChange={handleChange} required />

        <label>Year Of Study :</label>
        <select name="year" value={form.year} onChange={handleChange} required>
          <option value="">Select a year...</option>
          <option>1st Year</option>
          <option>2nd Year</option>
          <option>3rd Year</option>
          <option>4th Year</option>
          <option>Graduate</option>
        </select>

        <label>Branch/Department:</label>
        <input name="branch" value={form.branch} onChange={handleChange} required />

        <label>Domains Of Internship:</label>
        <select name="domain" value={form.domain} onChange={handleChange} required>
                 <option value="">Select a Domain...</option>
          <option>Android App Development</option>
          <option>Artifical Inteligence</option>
          <option>AR/VR</option>
          <option>Autocad</option>
          <option>Bio Informatics</option>
          <option>Business Analytics</option>
          <option>C, C++ With DSA</option>
          <option>Car Design</option>
          <option>Cloud Computing</option>
          <option>Cyber Security</option>
          <option>Data Science</option>
          <option>Digital Markeing & Marketing</option>
          <option>Embedded Systems</option>
          <option>Finance</option>
          <option>Full Stack Web Development</option>
          <option>Generative AI</option>
          <option>Genetic Engineering</option>
          <option>Graphic Design</option>
          <option>Human Resources</option>
          <option>(HEV) Hybrid Electric Vehicle</option>
          <option>IC Engine</option>
          <option>Internet Of Things (IOT)</option>
          <option>Java</option>
          <option>Machine Learning With Python</option>
          <option>Mern Stack</option>
          <option>Nanoscience Nanotechnology</option>
          <option>Psychology</option>
          <option>Python</option>
          <option>Regulatory Affairs (In Pharma & Healthcare)</option>
          <option>Robotics</option>
          <option>Stock Market</option>
          <option>Supply Chain Management</option>
          <option>UI/UX Design</option>
          <option>VlSI Design</option>
          <option>Web Development</option>
        </select>

        <label>Any Referral Of Friends:</label>
        <input name="referral" value={form.referral} onChange={handleChange} />

        <button className="submit-btn">Submit</button>
      </form>
    </div>
  );
}
